import { useEffect, useState } from 'react';
import { Button, Card, Form, Image, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

const BannerModalAdd = ({
    show,
    handleClose,
    editBanner,
    handleAddBanner,
    parsingDataEdit }) => {

    const [dataBanner, setDataBanner] = useState({
        text: '',
        title: '',
        banner: '', // To store the Base64 image
        typeBanner: 'BANNER', // New field, default to 'BANNER'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDataBanner({
            ...dataBanner,
            [name]: value,
        });
    };

    useEffect(() => {
        if (parsingDataEdit) {
            setDataBanner({
                text: parsingDataEdit.text || '',
                title: parsingDataEdit.title || '',
                banner: parsingDataEdit.banner || '',
                typeBanner: parsingDataEdit.typeBanner || 'BANNER',
            });
        } else {
            setDataBanner({
                text: '',
                title: '',
                banner: '',
                typeBanner: 'BANNER',
            });
        }
    }, [parsingDataEdit]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setDataBanner((prev) => ({
                    ...prev,
                    banner: reader.result,
                }));
            };
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Show loading alert
        Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we save the banner.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (parsingDataEdit != null) {
                await editBanner(parsingDataEdit.id, dataBanner);
                Swal.fire({
                    icon: 'success',
                    title: 'Updated!',
                    text: 'Banner has been updated successfully.',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                await handleAddBanner(dataBanner);
                Swal.fire({
                    icon: 'success',
                    title: 'Added!',
                    text: 'Banner has been added successfully.',
                    timer: 1500,
                    showConfirmButton: false
                });
            }
            // Reset form and close modal after success
            setDataBanner({ text: '', title: '', banner: '', typeBanner: 'BANNER' });
            handleClose();
        } catch (error) {
            console.error('Error saving banner:', error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.message || 'Something went wrong. Please try again.',
                confirmButtonText: 'OK'
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Banner</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Text</Form.Label>
                        <Form.Control
                            type="text"
                            name="text"
                            value={dataBanner.text}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            type="text"
                            name="title"
                            value={dataBanner.title}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Type Banner</Form.Label>
                        <Form.Select
                            name="typeBanner"
                            value={dataBanner.typeBanner}
                            onChange={handleChange}
                            required
                        >
                            <option value="BANNER">Banner</option>
                            <option value="HERO">Hero</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>Image Banner</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </Form.Group>
                    {dataBanner.banner && (
                        <div className="mb-3">
                            <Image
                                src={dataBanner.banner}
                                alt="Preview"
                                fluid
                                rounded
                            />
                        </div>
                    )}
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default BannerModalAdd;  